import { Injectable } from '@angular/core';
import { Subject } from "rxjs/Subject";
import { Observable } from 'rxjs/Observable';
import { AngularFireDatabase, AngularFireList, AngularFireObject } from 'angularfire2/database';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as firebase from 'firebase/app';
@Injectable()
export class FireBaseService {
    constructor(private db: AngularFireDatabase, private fs: AngularFirestore) {
    }

    public getDTOs<T>(path: string): Observable<T[]> {
        let dtos: AngularFireList<T> = this.db.list(path);
        return dtos.valueChanges();
    }

    public getDTO<T>(path: string, id: string | number): Observable<T> {
        let doc: AngularFireObject<T> = this.db.object(`${path}/${id}`);
        return doc.valueChanges();
    }

    public getStore(path: string, id: string | number): Observable<firebase.firestore.DocumentReference> {
        let doc: AngularFirestoreDocument<firebase.firestore.DocumentReference> = this.fs.doc<firebase.firestore.DocumentReference>(`${path}/${id}`);
        return doc.valueChanges();
    }

    public getDocRef(path: string): Observable<firebase.firestore.DocumentReference> {
        return this.fs.doc<firebase.firestore.DocumentReference>(path).valueChanges();
    }

    public getDoc<T>(path: string): Observable<T> {
        return this.fs.doc<T>(path).valueChanges();
    }

    public query<T>(path: string, orderBy: string, queryField: string, queryValue: any, start: number, limit: number) {
        let docs = this.fs.collection<T>('path', ref => ref
            .orderBy(orderBy, 'asc')
            .where(queryField, '==', queryValue)
            .startAt(start)
            .limit(limit));

        return docs.valueChanges();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/firebase.service.ts